<template>
  <!-- This component has no visual output, it only watches display changes -->
</template>

<script setup>
import { watch, onMounted } from 'vue'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'

const store = useStore()
const { name, width, height, mdAndUp, smAndDown } = useDisplay()

// Function to update store with current breakpoint data
const updateBreakpoint = () => {
  const breakpointData = {
    name: name.value,
    width: width.value,
    height: height.value,
    mdAndUp: mdAndUp.value,
    smAndDown: smAndDown.value,
  }

  store.dispatch('device/updateBreakpoint', breakpointData)
}

// Watch for changes in breakpoint name (this will trigger on any breakpoint change)
watch(name, updateBreakpoint, { immediate: true })

// Also watch for window size changes that might not trigger name change
watch([width, height], updateBreakpoint)

// Set initial breakpoint on mount
onMounted(() => {
  updateBreakpoint()
})
</script>
